export var NodeHealthStatus;
(function(NodeHealthStatus) {
    NodeHealthStatus["Healthy"] = "healthy";
    NodeHealthStatus["Error"] = "error";
    NodeHealthStatus["Offline"] = "offline";
})(NodeHealthStatus || (NodeHealthStatus = {}));
